import React from "react";

const PendingCases: React.FC = () => {
    return (
        <div>Pending Cases Content</div>
    )
}

export default PendingCases;